/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Grounding_ModalitiesInputs */

const en_us2_plan_build_grounding_modalities = /** @type {(inputs: Plan_Build_Grounding_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you've practised before`)
};

const pt_br2_plan_build_grounding_modalities = /** @type {(inputs: Plan_Build_Grounding_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que você já praticou`)
};

const es_419_plan_build_grounding_modalities = /** @type {(inputs: Plan_Build_Grounding_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo que ya practicaste`)
};

const pt_pt2_plan_build_grounding_modalities = /** @type {(inputs: Plan_Build_Grounding_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que já praticaste`)
};

const fr_fr2_plan_build_grounding_modalities = /** @type {(inputs: Plan_Build_Grounding_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce que tu as déjà pratiqué`)
};

const de_de2_plan_build_grounding_modalities = /** @type {(inputs: Plan_Build_Grounding_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was du schon betrieben hast`)
};

const it_it2_plan_build_grounding_modalities = /** @type {(inputs: Plan_Build_Grounding_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa hai già praticato`)
};

/**
* | output |
* | --- |
* | "What you've practised before" |
*
* @param {Plan_Build_Grounding_ModalitiesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_grounding_modalities = /** @type {((inputs?: Plan_Build_Grounding_ModalitiesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Grounding_ModalitiesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_grounding_modalities(inputs)
	if (locale === "es-419") return es_419_plan_build_grounding_modalities(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_grounding_modalities(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_grounding_modalities(inputs)
	if (locale === "de-DE") return de_de2_plan_build_grounding_modalities(inputs)
	if (locale === "it-IT") return it_it2_plan_build_grounding_modalities(inputs)
	return en_us2_plan_build_grounding_modalities(inputs)
});
export { plan_build_grounding_modalities as "plan-build.grounding_modalities" }